export const TOGGLE_DMX_CONTROLLER_STATUS = 'TOGGLE_DMX_CONTROLLER_STATUS';
export const TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL = 'TOGGLE_DMX_CONTROLLER_STATUS_SUCCESSFUL';
export const TOGGLE_DMX_CONTROLLER_STATUS_FAILED = 'TOGGLE_DMX_CONTROLLER_STATUS_FAILED';
